<template>
  <div class="survey-ani-card-content"
    :class="_classObj">
    <transition enter-active-class="slideInUp"
      leave-active-class="fadeOut">
      <div class="chat-inner"
        :class="_supportAnimationClass"
        v-show="enter">
        <!-- 问答区域 -->
        <template v-if="!isContentOfNoInputControl">
          <section class="msg-item req">
            <transition enter-active-class="fadeInUp"
              leave-active-class="fadeOut">
              <div class="msg-item-inner"
                :class="_supportAnimationClass"
                v-show="appear">
                <div class="tub">
                  <i class="avatar a1" />
                </div>
                <div class="cnt">
                  <span class="loading-cnt"
                    v-show="isRequestLoading">
                    <i class="weui-loading" />
                  </span>
                  <transition @enter="_onRequestTextEnter">
                    <div class="msg-cnt"
                      v-show="!isRequestLoading">
                      <div class="inner-text"
                        v-html="item.titleHtml || item.title"
                        @click="_onInnerTextClick"></div>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </section>
        </template>
        <template v-else>
          <section class="msg-item tip">
            <transition enter-active-class="fadeInUp"
              leave-active-class="fadeOut">
              <div class="inner-text">
                <slot name="input"
                  :cbs="cbs" />
              </div>
            </transition>
          </section>
        </template>

        <!-- 回应区域 -->
        <template v-if="!isContentOfNoInputControl">
          <section class="msg-item res"
            :class="_classResponseMsgItem">
            <div class="tub">
              <i class="avatar a2" />
            </div>
            <div class="cnt">
              <!-- 回答结果显示 -->
              <div class="control-response"
                :class="{ [`is-hidden`]: isShowInputControl }"
                ref="elControlResponse">
                <div class="res-value">
                  <div class="inner-text"
                    @click="_onToggleResponseControl"
                    v-if="!hasBranchQuestion">
                    <div v-html="localResponseValue"></div>
                  </div>
                  <div class="inner-text"
                    v-else>
                    <div v-html="localResponseValue"></div>
                  </div>

                  <!-- toggle input -->
                  <template v-if="!hasBranchQuestion">
                    <button @click="_onToggleResponseControl"
                      class="edit">
                      edit
                    </button>
                  </template>
                </div>
              </div>

              <!-- 回答输入组件 -->
              <div class="control-input"
                :class="{
                  [`is-value-mode`] : !_toggleShowInput,
                  [`is-no-actions`] : noActions
                }"
                :style="_appearInputStyle"
                @transitionend="_onControlInputTransitionEnd"
                ref="elControlInput">
                <!--                <transition-->
                <!--                    @enter="_onControlInputToggleEnter"-->
                <!--                    @leave="_onControlInputToggleLeave"-->
                <!--                >-->
                <div class="control-input-inner"
                  v-show="_toggleShowInput">
                  <slot name="input"
                    :cbs="cbs" />

                  <!-- toggle input -->
                  <div class="actions"
                    v-show="!noActions">
                    <one-button @click.native="_onToggleResponseControl(true)"
                      type="primary"
                      plain>
                      继续
                    </one-button>
                  </div>

                  <!-- suggestion -->
                  <div class="suggestion"
                    v-if="item.suggest">
                    <div class="inner"
                      v-html="item.suggestHtml"></div>
                  </div>
                </div>
                <!--                </transition>-->
              </div>
            </div>
          </section>
        </template>
        <!--        <template v-else>-->
        <!--          <section-->
        <!--            class="msg-item res"-->
        <!--            :class="_classResponseMsgItem"-->
        <!--          >-->
        <!--            <slot name="input" :cbs="cbs"/>-->
        <!--          </section>-->
        <!--        </template>-->
      </div>
    </transition>
  </div>
</template>

<script>
import { injectMixins } from '@/services'
import { INPUT_TYPES } from '@/pages/Survey/utils'
import { STATE_RESOLVED, STATE_RESOLVING } from '@/components/AniStageCards/helpers'

let uid = 0
const CONTENT_ANIMATION_START = 'content-animation-start'
const CONTENT_ANIMATION_END = 'content-animation-end'

export default {
  name: 'AniCardContentAdapter',

  mixins: [
    injectMixins
  ],

  props: {
    item: {},
    ownerState: {},
    vwSize: {},
    beforeSubmit: {},
    index: {},
    supportAnimation: {
      type: Boolean,
      default: true
    },
  },

  data () {
    return {
      identifier: (++uid),
      enter: false,
      appear: false, // 是否已经首次进场
      flyInControlInput: false, // 飞入控件容器
      isFlyingInput: false,
      isShowInputControl: true,
      isToggleShowInputControl: true,
      controlInputCntSize: null,
      isRequestLoading: true,
      responseCntSize: null, // 占位布局，一般会容器最小高度
      localResponseValue: '',
      localInputAdapterValue: null,
      localInputSelectedRawRefOption: null,
      cbs: this._setupCbs(),
      noActions: false // 是否现实下面的控制按钮
    }
  },

  created () {
    this.$watch('_classObj', (o, p) => {
      if (o && o.enter && (!p || !p.enter)) {
        this.enter = true

        // TODO: wait Requester loading ...
        this._waitForAppearRequester()
          .then(() => {
            this.flyInControlInput = true

            // TODO: improve
            this.$nextTick(() => {
              this.isFlyingInput = true

              if (!this.supportAnimation) {
                this._onControlInputTransitionEnd()
              }
            })
          })
      }
    }, {
      immediate: true
    })

    this.$watch('isFlyingInput', (a) => {
      if (a) {
        // TODO: emit content animation DONE
        this.$emit(CONTENT_ANIMATION_START)
      } else {
        this.$emit(CONTENT_ANIMATION_END)
      }
    })

    this.$watch('ownerState', (a) => {
      if (a === STATE_RESOLVING) {
        this.cbs.refActiveHandler.fn && this.cbs.refActiveHandler.fn()
      }
    }, {
      immediate: true
    })
  },

  methods: {
    _onInnerTextClick (e) {
      let el = null
      if (e && (el = e.target) && el.nodeName.toLowerCase() === 'img') {
        const src = el.getAttribute('src')

        if (src) {
          this.$emit('image-preview', src)
        }
      }
    },

    _setupCbs () {
      const vm = this
      const refActiveHandler = {
        fn: null
      }

      return {
        refActiveHandler,

        setResponseValue (val) {
          vm.localResponseValue = val
        },

        syncLocalInputValue (val) {
          vm.localInputAdapterValue = val
        },

        tryNextCardItem: this._onToggleResponseControl.bind(this, true),

        setNoActionsControl (flag = true) {
          vm.noActions = flag
        },

        onCardActive (handler) {
          refActiveHandler.fn = handler
        }
      }
    },

    _onRequestTextEnter (target, done) {
      const wrapEl = target.closest('.cnt')

      if (this.supportAnimation) {
        wrapEl.classList.add('is-wait-for-real-msg')

        setTimeout(() => {
          wrapEl.classList.add('is-gone')
        }, 24)
      } else {
        // wrapEl.classList.add('is-gone')
      }
    },

    _onControlInputToggleEnter (target, done) {
      setTimeout(() => {
        target.style.height = `${this.controlInputCntSize.height}px`
        target.style.opacity = `1`

        target.addEventListener('transitionend', () => {
          done()
        }, {
          once: true
        })
      }, 1)
    },

    _onControlInputToggleLeave (target, done) {
      target.style.height = `${this.controlInputCntSize.height}px`

      setTimeout(() => {
        target.style.height = `${this.responseCntSize.height}px`
        target.style.opacity = `0`
        target.addEventListener('transitionend', () => {
          done()
        }, {
          once: true
        })
      }, 1)
    },

    async _onToggleResponseControl (isSubmit, selectedRawRefOption = null) {
      const showNext = () => {
        this.isShowInputControl = !this.isShowInputControl
        this.isToggleShowInputControl = !this.isToggleShowInputControl
      }

      // TODO: ---
      if (isSubmit === true) {
        if (this.beforeSubmit) {
          await this.beforeSubmit(this.index, this, selectedRawRefOption)
        }

        this.localInputSelectedRawRefOption = selectedRawRefOption

        setTimeout(() => {
          this.$emit('submitted', [this.index, selectedRawRefOption])
        }, 100)

        showNext()

        return
      }

      showNext()
    },

    async _waitForAppearRequester () {
      if (!this.supportAnimation) {
        this.appear = true
        this.isRequestLoading = false
        return
      }

      await new Promise(resolve => {
        setTimeout(() => {
          this.appear = true
        }, 24)

        setTimeout(() => {
          this.isRequestLoading = false
        }, 500)

        // TODO: refactor
        const WAIT_SCROLL_VW = this.index !== 0 ? (1000 / 1.6) : 0
        const WAIT_REQUEST_LOADING = 1000
        setTimeout(resolve, WAIT_SCROLL_VW + WAIT_REQUEST_LOADING)
      })
    },

    _onControlInputTransitionEnd (e) {
      const target = (e && e.target) || this.$refs.elControlInput

      if (this.isFlyingInput) {
        console.debug('[control-input] transition end', target)

        // if no control input panel
        // the target is not exist
        if (target) {
          const inputCntEl = target

          // TODO: dynamic
          this.controlInputCntSize = {
            width: inputCntEl.offsetWidth,
            height: inputCntEl.offsetHeight
          }

          this._resolveControlResponseCntSize()
        }

        this.isFlyingInput = false
      }
    },

    _resolveControlResponseCntSize () {
      const responseCntEl = this.$refs.elControlResponse

      this.responseCntSize = {
        width: responseCntEl.offsetWidth,
        height: responseCntEl.offsetHeight
      }
    },

    getInputAdapterValue () {
      if (Array.isArray(this.localInputAdapterValue)) {
        return this.localInputAdapterValue.map(v => {
          return {
            subCode: this.item.code,
            subAnswer: v // TODO: 这个是题目标志ID
          }
        })
      } else {
        return [{
          subCode: this.item.code,
          subAnswer: this.localInputAdapterValue
        }]
      }
    }
  },

  computed: {
    isContentOfNoInputControl () {
      return this.item.inputType === INPUT_TYPES.SHOW_TIP
    },

    hasBranchQuestion () {
      return this.item
        && Array.isArray(this.item.question)
        && this.item.question.some(it => !!it.nextCode)
    },

    _supportAnimationClass () {
      const obj = {}

      if (this.supportAnimation) {
        obj.animated = true
      }

      return obj
    },

    _toggleShowInput () {
      return this.isToggleShowInputControl
    },

    _appearInputStyle () {
      const obj = {}
      let translateY = 0
      let opacity = 1

      if (!this.flyInControlInput) {
        translateY = this.vwSize.height * 0.3
        opacity = 0
      }

      // TODO: stop fly in
      obj.webkitTransform = obj.transform = `translateY(${translateY}px)`
      obj.opacity = opacity

      return obj
    },

    _classObj () {
      const obj = {}

      switch (this.ownerState) {
        case STATE_RESOLVING: {
          obj.enter = true
          obj.leave = false
          break
        }
        case STATE_RESOLVED: {
          obj.enter = false
          obj.leave = true
        }
      }

      if (this.isContentOfNoInputControl) {
        obj[`is-content-of-no-input-control`] = true
      } else {
        obj[`is-content-of-no-input-control`] = false
      }

      if (!this.supportAnimation) {
        obj[`is-not-support-animation`] = true
      }

      return obj
    },

    _classResponseMsgItem () {
      const obj = {}

      if (this.isShowInputControl) {
        obj[`is-input-mode`] = true
      }

      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.weui-btn {
  border: 1px solid #3dd3cb;
  color: #3dd3cb;
}
</style>